import React from 'react';
import AttributeButton from './attribute-button';

const AttributeButtonsList = ({ itemAttributesForFilter, onClick }) => {
    const attributeButtons = [];
    itemAttributesForFilter.map(attribute => {
        attributeButtons.push(
            <AttributeButton
                key={attribute.name}
                className="mt-0 mr-2"
                text={attribute.values.join('/')}
                onClick={() => onClick(attribute)}
            />
        );
    });

    return attributeButtons;
};
export default AttributeButtonsList;
